// // src/App.js
// import React from "react";
// import {
//   BrowserRouter as Router,
//   Route,
//   Routes,
//   useLocation,
// } from "react-router-dom";
// import { TranslationProvider } from "./pages/Translation/TranslationContext";
// import Layout from "./pages/Layout/BasicLayout"; // Only focusing on Login
// import Login from "./pages/NewLoginTemp/Login"; // Only focusing on Login

// // Component to handle client page with query params
// function ClientPage() {
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const clientId = queryParams.get("clientId");
//   const queryD = queryParams.get("d"); // If you have other query params you can get them here

//   return <Login clientId={clientId} queryD={queryD} />;
// }

// // Main App component with routing setup
// const App = () => {
//   return (
//     <div>
//       {/* <TranslationProvider> */}
//         <Layout>
//           <Router>
//             <Routes>
//               <Route path="/client" element={<ClientPage />} />{" "}
//             </Routes>
//           </Router>
//         </Layout>
//       {/* </TranslationProvider> */}
//     </div>
//   );
// };

// export default App;
// // https://mani.fts.hyperthings.in


import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import routes from "./utils/routes"; // Import routes from your route definitions
import Login from "./pages/NewLoginTemp/Login"; // Import the Login page

const App = () => {
  return (
    <Router>
      <AppWithRouter />
    </Router>
  );
};

const AppWithRouter = () => {
  const location = useLocation(); // Access location object to get query params
  const queryParams = new URLSearchParams(location.search); // Extract query params
  const clientId = queryParams.get("clientId"); // Get the 'clientId' query param

  // If you want to pass the clientId to the Login page, you can do so here
  return (
    <Routes>
      {/* Render other routes dynamically */}
      {routes.map((route, index) => {
        const Layout = route.layout || React.Fragment; // Default layout is React.Fragment
        return (
          <Route
            key={index}
            path={route.path}
            element={<Layout>{route.element}</Layout>}
          />
        );
      })}

      {/* Pass the clientId to the Login component */}
      <Route
        path="/"
        element={<Login clientId={clientId} />}
      />
    </Routes>
  );
};

export default App;

